/** Canonical emoji form — matches backend EmojiNormalizer (NFC, no VS15/VS16). */
export const normalizeEmoji = (emoji) => {
  if (!emoji) return '';
  return String(emoji)
    .normalize('NFC')
    .replace(/\uFE0E|\uFE0F/g, '')
    .trim();
};

/** Merge duplicate reaction rows (same emoji, different encodings) for display. */
export const mergeReactionsForDisplay = (reactions = []) => {
  const merged = new Map();
  reactions.forEach((reaction) => {
    const key = normalizeEmoji(reaction?.emoji);
    if (!key) return;
    const userIds = reaction.userIds || [];
    const existing = merged.get(key);
    if (existing) {
      const ids = new Set([...(existing.userIds || []), ...userIds]);
      existing.userIds = [...ids];
    } else {
      merged.set(key, { emoji: key, userIds: [...userIds] });
    }
  });
  return [...merged.values()];
};

export const userHasReacted = (reaction, userId) =>
  Boolean(userId && (reaction?.userIds || []).includes(userId));
